import api from "../api";

const changePassword = async (oldPassword, newPassword) => {
  const requestData = {
    oldPassword: oldPassword,
    newPassword: newPassword

  };

  try {
    const response = await api.post(
      process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/auth/reset-password",
      requestData
    );

    // Check if the status code indicates success (typically 200 or 201)
    if (response.status === 200 || response.status === 201) {

      return response.data; // Optionally return the response data
    } else {
      console.error("Reset failed with status:", response.status);
      return null; // Return null or handle as necessary
    }
  } catch (error) {
    console.error("There was a problem with the axios operation:", error);
    throw error; // Rethrow the error so it can be handled elsewhere
  }
};

export default changePassword;
